module.exports = __webpack_public_path__ + "static/img/gh_54de91dcb978_344.7839f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fc/gh_54de91dcb978_344.png
// module id = 0hyM
// module chunks = 0